import { StartChatPage } from "@/components/start-chat/start-chat-page.tsx";
import { MAX_CHAT_START_ARTIFACTS } from "@/hooks/use-artifact-navigation.ts";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/home")({
	component: HomeRouteComponent,
	validateSearch: z.object({
		artifactId: z.string().uuid().optional(),
		/**
		 * Two or more artifacts to start one chat from; a single one keeps using
		 * `artifactId` above, which additionally pins it as ACTIVE.
		 *
		 * `.catch` rather than a hard failure so a hand-edited or truncated URL
		 * lands on an ordinary new-chat page instead of the error boundary.
		 */
		artifactIds: z
			.array(z.string().uuid())
			.min(1)
			.max(MAX_CHAT_START_ARTIFACTS)
			.optional()
			.catch(undefined),
	}),
	head: () => ({
		meta: [{ title: pageTitle() }],
	}),
});

function HomeRouteComponent() {
	const { artifactId, artifactIds } = Route.useSearch();
	return <StartChatPage artifactId={artifactId} artifactIds={artifactIds} />;
}
